import BlackToast from './BlackToast';

export default BlackToast;
